module.exports = __webpack_public_path__ + "media/images/doctor_profiles/default/profile_noimage_726x419-c6846ae02d99ca4addc2f34a7b845e5f.png";